// ----------------------------------------------------------------------

export default function IconButton(theme) {
  return {
    MuiIconButton: {
      variants: [
        {
          props: { color: "default" },
          style: {
            "&:hover": { backgroundColor: theme.palette.action.hover },
          },
        },
        {
          props: { color: "inherit" },
          style: {
            "&:hover": { backgroundColor: theme.palette.action.hover },
          },
        },
      ],

      styleOverrides: {
        root: {
          "&:focus:not(:focus-visible)": {
            outline: "none",
          },
          "&:focus-visible": {
            outline: "2px solid #4C7DF0",
            outlineOffset: "2px",
          },
        },
      },
    },
  };
}
